import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material'; // Usa Material come base

const MyPreset = definePreset(Material, {
    semantic: {
        primary: {
            50: '#E8E7FE',
            100: '#C5C3FC',
            200: '#A19FFA',
            300: '#7E7BF7',
            400: '#5A57F5',
            500: '#4F46E5', // Primary base
            600: '#453ED0',
            700: '#3A36B8',
            800: '#2F2E9F',
            900: '#242687',
            950: '#1A1E6F'
        },
        secondary: {
            50: '#E4F4F4',
            100: '#BCDCDC',
            200: '#95C4C4',
            300: '#6EABAB',
            400: '#479393',
            500: '#5F9EA0', // Secondary base
            600: '#538B8B',
            700: '#476F6F',
            800: '#3B5252',
            900: '#2F3636',
            950: '#232020'
        },
        success: {
            50: '#ECFDF5',
            100: '#D1FAE5',
            200: '#A7F3D0',
            300: '#6EE7B7',
            400: '#34D399',
            500: '#10B981', // Success base
            600: '#059669',
            700: '#047857',
            800: '#065F46',
            900: '#064E3B',
            950: '#083D2D'
        },
        warning: {
            50: '#FEFCE8',
            100: '#FEF3C7',
            200: '#FDE68A',
            300: '#FCD34D',
            400: '#FBBF24',
            500: '#F59E0B', // Warning base
            600: '#D97706',
            700: '#B45309',
            800: '#92400E',
            900: '#78350F',
            950: '#5C290E'
        },
        error: {
            50: '#FEF2F2',
            100: '#FEE2E2',
            200: '#FECACA',
            300: '#FCA5A5',
            400: '#F87171',
            500: '#DC2626', // Error base
            600: '#B91C1C',
            700: '#991B1B',
            800: '#7F1D1D',
            900: '#6B1717',
            950: '#580D0D'
        },
        info: {
            50: '#EFF6FF',
            100: '#DBEAFE',
            200: '#BFDBFE',
            300: '#93C5FD',
            400: '#60A5FA',
            500: '#3B82F6', // Info base
            600: '#2563EB',
            700: '#1D4ED8',
            800: '#1E40AF',
            900: '#1E3A8A',
            950: '#1E2E6A'
        }
    }
});

export default MyPreset;
